module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth",
    attrs: {
      "id": "login"
    }
  }, [_c('h1', {
    staticClass: "auth__title text-center"
  }, [_vm._v("Log In")]), _vm._v(" "), (_vm.error) ? _c('message', {
    attrs: {
      "text": _vm.error
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "auth__form"
  }, [_vm._l((_vm.fields), function(field) {
    return _c('field', {
      attrs: {
        "name": field.name,
        "type": field.type,
        "placeholder": field.placeholder,
        "autofocus": field.autofocus
      },
      model: {
        value: (field.value),
        callback: function($$v) {
          field.value = $$v
        },
        expression: "field.value"
      }
    })
  }), _vm._v(" "), _c('p', [_vm._v("* " + _vm._s(_vm.$t('Required_fields')))]), _vm._v(" "), _c('button', {
    staticClass: "auth__form__button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onLogIn($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onLogIn($event)
      }
    }
  }, [_vm._v("\n\t  Log In\n\t")])], 2), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup',
        query: {
          email: this.fields.email.value
        }
      }
    }
  }, [_vm._v("\n\tNew here? Sign up\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-500dc8dd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/LogIn.vue
// module id = 2146
// module chunks = 0